import { of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { mergeMap, catchError, filter } from "rxjs/operators";
import { ofType } from "redux-observable";
import { authHeaders, getOrganisationBaseUrl } from "frame";
import Types from "../actions/types";
import { onSaveFailed, onSaveSuccess } from "../actions";

const taskTypeSaveEffect = (action$, state$) =>
	action$.pipe(
		ofType(Types.TASK_TYPE_UPDATE_REQUESTED),
		filter(() => state$.value.organisations.currentOrganisation),
		mergeMap(({ payload }) =>
			ajax
				.post(
					`${getOrganisationBaseUrl(
						state$.value
					)}/organisation-task-type/update`,
					payload,
					authHeaders()
				)
				.pipe(
					mergeMap((ajaxResponse) =>
						of(onSaveSuccess(ajaxResponse.response))
					),
					catchError((error) => of(onSaveFailed(error)))
				)
		)
	);

export default taskTypeSaveEffect;
